import React, { useEffect, useState } from 'react'
import {
  Typography,
  Button,
  LinearProgress,
  Box,
  IconButton,
  CircularProgress,
} from '@material-ui/core'
import classNames from 'classnames'
import CloseIcon from '@material-ui/icons/Close'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import Wrapper from '../../../../../Common/Wrapper/Wrapper'
import useStyles from './FirmwareUpdatePopup.style'
import { setFirmwareForUpdate, startFirmwareUpdate, resetFirmwareStatus } from '../../../../../../actions/firmware'
import { selectMezzo } from '../../../../../../actions/mezzoDevices'


const FirmwareUpdatePopup = ({
  setCurrentFirmware, setIsFirmwarePopupOpen, firmwareStatus,
}) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [isStartButtonPressed, setIsStartButtonPressed] = useState(false)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  const renderButton = () => {
    switch (firmwareStatus.step) {
    case 'Success! Rebooting device':
      return (
        <Button
          className={classNames(
            classes.updateFirmwareButton,
            firmwareStatus.totalProgress === 100 && classes.doneButton,
          )}
          variant="contained"
          color="primary"
          onClick={() => {
            setIsFirmwarePopupOpen(false)
            dispatch(setFirmwareForUpdate(''))
            dispatch(resetFirmwareStatus())
            dispatch(selectMezzo({
              serial: 'N/A',
              identifier: 'N/A',
              ssid: 'N/A',
              ip: 'N/A',
            }))
            setCurrentFirmware(null)
          }}
        >
          Done
        </Button>
      )
    case 'Firmware update failed':
      return (
        <Button
          className={classes.updateFirmwareButton}
          variant="contained"
          color="primary"
          onClick={() => {
            setIsFirmwarePopupOpen(false)
            dispatch(setFirmwareForUpdate(''))
            dispatch(resetFirmwareStatus())
            dispatch(selectMezzo({
              serial: 'N/A',
              identifier: 'N/A',
              ssid: 'N/A',
              ip: 'N/A',
            }))
            setCurrentFirmware(null)
          }}
        >
          Close
        </Button>
      )
    default:
      return (
        <Button
          className={classes.updateFirmwareButton}
          variant="contained"
          color="primary"
          disabled={firmwareStatus.totalProgress !== 0 || isStartButtonPressed}
          onClick={() => {
            setIsStartButtonPressed(true)
            dispatch(startFirmwareUpdate())
          }}
        >
          {firmwareStatus.totalProgress !== 0 || isStartButtonPressed
            ? <CircularProgress className={classes.circularProgress} /> : 'Start'}
        </Button>
      )
    }
  }

  return (
    <Wrapper className={classes.firmwarePopup}>
      <Wrapper className={classes.startAndProgressWrapper}>
        {firmwareStatus.step === '' && (
          <IconButton
            className={classes.closeIcon}
            variant="out"
            color="primary"
            onClick={() => {
              setIsFirmwarePopupOpen(false)
              dispatch(setFirmwareForUpdate(''))
              dispatch(resetFirmwareStatus())
              setCurrentFirmware(null)
            }}
          >
            <CloseIcon />
          </IconButton>
        )}
        <Wrapper className={classes.linearProgressWrapper}>
          <Typography className={classes.title}>Firmware update</Typography>
          {firmwareStatus.step !== '' && (
            <>
              <Typography className={classes.firmwareStep}>
                {`${firmwareStatus.step}: ${firmwareStatus.progress}%`}
              </Typography>
              <LinearProgress
                className={classes.firmwareProgress}
                variant="determinate"
                value={firmwareStatus.totalProgress}
              />
              <Box className={classes.progressValue}>
                <Typography variant="body2">
                  {`${Math.round(firmwareStatus.totalProgress)}%`}
                </Typography>
              </Box>
              {firmwareStatus.totalProgress !== 100 && (
                <Typography className={classes.sleepTip}>
                  {/* eslint-disable-next-line max-len */}
                  Firmware update is in progress. To ensure a successful update, kindly keep your device awake and active during this process, as it may take some time.
                </Typography>
              )}
            </>
          )}
        </Wrapper>
        {renderButton()}
      </Wrapper>
    </Wrapper>
  )
}

FirmwareUpdatePopup.propTypes = {
  firmwareStatus: PropTypes.shape({
    step: PropTypes.string,
    progress: PropTypes.number,
    totalProgress: PropTypes.number,
  }).isRequired,
  setCurrentFirmware: PropTypes.func.isRequired,
  setIsFirmwarePopupOpen: PropTypes.func.isRequired,
}

export default FirmwareUpdatePopup
